import routeTypes from './route-types'

const SystemMessageView = () => import(/* webpackChunkName: "superadmin-systemmessage-chunk" */ './SystemMessageView.vue')
const SystemMessageDetail = () => import(/* webpackChunkName: "superadmin-systemmessage-chunk" */ './SystemMessageDetail.vue')

export default [
  {
    path: routeTypes.SystemMessageView.path,
    name: routeTypes.SystemMessageView.name,
    component: SystemMessageView,
    meta: {
      title: 'System Message'
    },
    children: [
      {
        path: '',
        name: routeTypes.SystemMessageDetail.name,
        component: SystemMessageDetail,
        meta: {
          title: '',
          access: {
            isAdd: true
          }
        }
      }
    ]
  }
]
